import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Badge, Button, message, Popover } from "antd";
import { useNotification } from "context/NotificationContext";
import { useAuth } from "components/auth/AuthContext";
import { BellOutlined } from "@ant-design/icons";


const NotificationDropdown = () => {
  const { notifications = [], markAllRead } = useNotification();
  const { getUserInfo } = useAuth();
  const { role } = getUserInfo();
  const navigate = useNavigate();

  const roleRoutes = {
    tdr: "/tdrOrders",
    tmm: "/tmOrders",
    admin: "/orders",
  };

  const handleViewAll = () => {
    if (role === "client") {
      message.warning("⚠️ This page has not been enabled for your account yet.");
      return;
    }
    const route = roleRoutes[role];
    if (route) navigate(route);
    else message.info("Page route not configured for this role.");
  };

  // Content block injected inside the clean Popover modal frame
  const dropdownContent = (
    <div className="modern__notif__panel">
      <div className="notif__panel__header">
        <span className="notif__title">🛎️ New Orders</span>
        {notifications.length > 0 && (
          <Button type="link" size="small" onClick={markAllRead} className="mark__all__btn">
            Mark all as read
          </Button>
        )}
      </div>

      <div className="notif__panel__body">
        {notifications.length > 0 ? (
          <ul className="notif__panel__list">
            {notifications.map((order, idx) => (
              <li key={order.id || idx} className="notif__panel__item">
                <div className="notif__item__bullet" />
                <div className="notif__item__content">
                  <span className="notif__item__order">Order #{order.id}</span>
                  <span className="notif__item__customer">{order.customer_phone || "Unknown Outlet"}</span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="notif__panel__empty">
            <span className="empty__icon">✨</span>
            <p>All caught up! No new orders.</p>
          </div>
        )}
      </div>

      <div className="notif__panel__footer">
        <Button 
          type="text" 
          block 
          icon={<FaChevronRight style={{ fontSize: 10 }} />} 
          className="view__all__btn"
          disabled={role === "client"}
          onClick={handleViewAll}
        >
          View All Orders
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      content={dropdownContent}
      trigger="click"
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      overlayClassName="clean__notif__popover"
    >
      <div className="header__action__bell">
        <Badge count={notifications.length} offset={[-2, 2]} color="#ff4d4f" size="small">
          <Button type="text" shape="circle" icon={<BellOutlined style={{ fontSize: 20, color: "#595959" }} />} />
        </Badge>
      </div>
    </Popover>
  );
};

export default NotificationDropdown;